'use client';
import { ReactNode, useRef } from 'react';
import Slider from 'react-slick';
import { MainSlide } from '@/components/pages/MainPage/MainSlider/MainSlide/MainSlide';
import { Announcement } from '@/api/announcements/announcements.types';
import { ButtonArrow } from '@/components/ui/ButtonArrow/ButtonArrow';
import { SliderDot } from '@/components/ui/SliderDot/SliderDot';
import s from './MainSlider.module.scss';
import './main-slider.css';

const settings = {
  dots: true,
  arrows: false,
  infinite: true,
  speed: 500,
  autoplay: true,
  autoplaySpeed: 3000,
  slidesToShow: 1,
  dotsClass: `custom-dots ${s.section__sliderDots}`,
  appendDots: (dots: ReactNode) => <ul>{dots}</ul>,
  customPaging: () => <SliderDot />,
};

export const MainSlider = ({ slides }: { slides: Announcement[] }) => {
  const sliderRef = useRef<Slider | null>(null);
  const isOnlyOneSlide = slides.length === 1;

  return (
    <section className={s.section}>
      {isOnlyOneSlide
        ? <MainSlide key={slides[0].id} slide={slides[0]} />
        : (
          <Slider className={s.section__slider} ref={sliderRef} {...settings}>
            {slides.map((slide) => <MainSlide key={slide.id} slide={slide} />)}
          </Slider>
        )
      }

      {!isOnlyOneSlide && (
        <div className={s.section__nav}>
          <div className={s.section__navInner}>
            <div className={s.section__buttons}>
              <ButtonArrow onClick={() => sliderRef.current?.slickPrev()} transparent />
              <ButtonArrow onClick={() => sliderRef.current?.slickNext()} transparent reverse />
            </div>
          </div>
        </div>
      )}
    </section>
  );
};